import { isEmpty } from '@sgme/fp';
import { Decimal } from 'decimal.js-light';
import type { MessageFormatter } from 'locales/types';

export function getPercentageString(
  decimal: number,
  nbDecimals: number = 3,
  removeTrailingZeros: boolean = false,
): string {
  const formattedNumber = new Decimal(decimal).times(100).toFixed(nbDecimals);
  return `${removeTrailingZeros ? formattedNumber.replace(/0+$/, '') : formattedNumber}%`;
}

export function parsePastedNumber(text: string | undefined): number | undefined {
  if (isEmpty(text)) {
    return undefined;
  }
  const result = Number(text.replace('%', ''));
  if (isNaN(result)) {
    return undefined;
  }
  return result;
}

export function parsePastedNumberWithErrorMessage(
  text: string | undefined,
  formatError: MessageFormatter,
): number | undefined {
  if (isEmpty(text)) {
    return undefined;
  }
  const result = Number(text.replace('%', ''));
  if (isNaN(result)) {
    const msg = formatError(
      { id: 'moreMenu.pasteFromClipboard.error.invalidNumber' },
      {
        text,
      },
    );
    throw new Error(msg);
  }
  return result;
}
